

/**
 * Unique fields in collection: [
  'lastname',
  
  'index',
  'hidden',
  'ownlanguage',
  'firstname',
  'title',
  'type',
  
  'nationality',
  
  

    'description',
    'fields',
    'education',
    'professionalServices',
    'awards',
    'email',
]
 * 
 */

import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { fetchMemberByEmail, manuallyModifyMembers, regenerateAllIDs, updateMemberDetail } from "../contexts/fetchMemberData";
import { ColMemberDetails, ColMemberImg } from "./MemberComp";
import { Button, Row } from "react-bootstrap";
import { EditModal } from "./Modals";

const memberStructure = [
    {
        title: "Name in your language (optional)",
        type: "text",
        field: "ownlanguage",
        init: "",
    },
    {
        title: "Introduction",
        type: "textarea",
        field: "description",
        init: "",
    },
    {
        title: "Research Fields",
        type: "array-text",
        field: "fields",
        init: [],
    },
    {
        title: "Education Background",
        type: "timeline",
        field: "education",
        init: [],
    },
    
    {
        title: "Professional Services",
        type: "timeline",
        field: "professionalServices",
        init: [],
    },
    {
        title: "Awards",
        type: "array-text",
        field: "awards",
        init: [],
    },
    {
        title: "Emails",
        type: "array-text",
        field: "email",
        init: [],
    },
    {
        title: "Short Description",
        type: "text",
        field: "shortDescription",
        init: "",
    },
    {
        title: "Links",
        type: "links",
        field: "links",
        init: [],
    },
    {
        title: "Key Publications",
        type: "publications",
        field: "publications",
        init: [],
    },
]

const DBMember = () => {
    const [data, setData] = useState({});
    const [eData, setEData] = useState({});
    const [isShowE, setShowE] = useState(false);

    const { user } = useContext(AuthContext)

    useEffect(() => {
        if (user?.email) {
            fetchMemberByEmail(user?.email, setData)
        }
        return () => {
            setData({})
            setEData({})
        }
    }, [user])


    const handleEditSubmit = async (e, formData) => {
        e.preventDefault();
        try {
            //await updateNewsFirestore(formData);
            await updateMemberDetail(formData)
            fetchMemberByEmail(user?.email, setData)
            setShowE(false);
        } catch (error) {
            console.error("Error in handleEditSubmit:", error);
            alert("Error updating news. Please try again.");
        }
    };

    return (
        <div>
            <Row>
                <div className="text-end"><Button variant="warning" onClick={() => {setEData(data); setShowE(true)}}>edit</Button></div>   
                <Button variant="warning" hidden onClick={() => manuallyModifyMembers(memberStructure)}>modify</Button> 
                <Button variant="warning" hidden onClick={() => regenerateAllIDs("members")}>backup</Button> 
                <ColMemberImg data={data} />
                <ColMemberDetails data={data} />
            </Row>
            <EditModal size='lg' isShowM={isShowE} setShowM={setShowE} structure={memberStructure} onSubmit={handleEditSubmit} existingData={eData}/>
        </div>
    )
}

export default DBMember;

